const reasons = {
  inDelay: 'servicio atrasado',
  inDelayMany: 'servicios atrasados',
  notDone: 'servicio obligatorio no realizado',
  notDoneMany: 'servicios obligatorios no realizados',
  hasActionsOpenedOrOverdue: 'servicio con acciones abiertas o vencidas',
  hasActionsOpenedOrOverdueMany: 'servicios con acciones abiertas o vencidas',
  hasNoServices: 'No tiene ningun servicio',
}

export default reasons;
